import { Phone, ArrowUpRight } from "lucide-react";
import { SERVICES, PHONE_HREF } from "@/data/site";
import { Reveal } from "./Reveal";

const ServiceCard = ({ s, i }) => (
  <Reveal delay={i * 0.08}>
    <article
      data-testid={`service-card-${s.id}`}
      className="group relative bg-white rounded-3xl overflow-hidden border border-rose-100 shadow-[0_8px_40px_rgba(194,24,91,0.06)] hover:shadow-[0_20px_60px_rgba(194,24,91,0.16)] transition-all duration-500 hover:-translate-y-2 flex flex-col h-full"
    >
      <div className="relative h-56 overflow-hidden">
        <img
          src={s.image}
          alt={s.title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/35 to-transparent" />
        <span className="absolute top-4 left-4 font-serif-display italic text-white/90 text-4xl drop-shadow">
          {s.num}
        </span>
      </div>
      <div className="p-6 sm:p-8 flex flex-col flex-1">
        <h3 className="font-serif-display text-xl sm:text-2xl font-semibold text-stone-900">
          {s.title}
        </h3>
        {s.desc && <p className="mt-2 text-sm text-stone-600 leading-relaxed">{s.desc}</p>}
        <ul className="mt-4 flex flex-wrap gap-2">
          {s.items.map((it) => (
            <li
              key={it}
              className="text-xs font-medium text-[#C2185B] bg-[#FCE4EC] px-3 py-1.5 rounded-full"
            >
              {it}
            </li>
          ))}
        </ul>
        <a
          data-testid="service-book-btn"
          href={PHONE_HREF}
          className="mt-6 pt-5 border-t border-rose-100 inline-flex items-center justify-between text-sm font-semibold text-stone-900 group-hover:text-[#C2185B] transition-colors duration-300 mt-auto"
        >
          <span className="inline-flex items-center gap-2">
            <Phone size={14} className="text-[#C2185B]" />
            Ligar e Agendar
          </span>
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
          />
        </a>
      </div>
    </article>
  </Reveal>
);

export const Services = () => (
  <section id="servicos" data-testid="services-section" className="py-16 sm:py-24 lg:py-32 marble-bg">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
      <Reveal>
        <p className="text-xs sm:text-sm font-medium tracking-[0.25em] uppercase text-[#C2185B]">
          Os Nossos Serviços
        </p>
        <div className="mt-4 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-stone-900 max-w-xl">
            Serviços pensados na sua <em className="text-[#C2185B]">estética</em>
          </h2>
          <p className="text-stone-600 max-w-sm text-sm sm:text-base leading-relaxed">
            Cada serviço é realizado com materiais esterilizados e o carinho de
            profissionais qualificadas.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 lg:mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.id} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);
